






























































































import { Component, Vue, Provide,Prop,Watch } from "vue-property-decorator";
import { MaritalStatusEnum,RelationshipEnum } from "@/enum/index";
const deleteDialog = () => import("@/views/peopleManagement/components/deleteDialog.vue");
import dataCenter from '@/request/requestIndex/index';
import ElImageViewer from "element-ui/packages/image/src/image-viewer.vue";


@Component({
    name: "family",
    components: { deleteDialog ,ElImageViewer}
})
export default class CombinationProperty extends Vue {
    @Prop() familyAdd: any;
    @Prop() familyDetail: any;
    @Prop() detailInfo: any;
    @Prop() baseUserInfo: any;
    @Prop() familyLoading:any;

    @Provide() private dialogVisible: Boolean = false;
    @Provide() private detailForm: any = {};
    @Provide() private url: any = '';
    @Provide() private imgShow: Boolean = false;
    
    @Provide() private imgPreviewList:any = []
    @Provide() private showImgViewer:Boolean = false
    @Provide() private btnType: string = 'primary';
    @Provide() private btnClick: Boolean = false;


    //家庭信息
    @Provide() private familyForm: any = {
        maritalstatus:'',
        childrennumber:'',
        familyaddress:'',
        familyaddrphoto: '',
        contactList:[],
        panelstatus:0,
        fileList:[]
    };
    
    @Provide() private MaritalStatusEnum: any = Reflect.ownKeys(MaritalStatusEnum).slice(1).map((item: any, index: number) => {
        let obj: {
            label: string;
            value: number | null;
        } = { label: "", value: null };
        switch (index) {
            case 0:
            obj.label = "formWrh.married";
            obj.value = 1
            break;
            case 1:
            obj.label = "formWrh.single";
            obj.value = 2
            break;
            case 2:
            obj.label = "formWrh.cohabitation";
            obj.value = 3
            break;
            case 3:
            obj.label = "formWrh.unmarried";
            obj.value = 4
            break;
        }
        // obj.value = index + 1;
        return obj;
    }); // 婚姻状况

    @Provide() private RelationshipEnum: any = Reflect.ownKeys(RelationshipEnum).slice(1).map((item: any, index: number) => {
        let obj: {
            label: string;
            value: number | null;
        } = { label: "", value: null };
        switch (index) {
            case 0:
            obj.label = "formWrh.parent";
            obj.value = 1
            break;
            case 1:
            obj.label = "formWrh.couple";
            obj.value = 2
            break;
            case 2:
            obj.label = "formWrh.children";
            obj.value = 3
            break;
            case 3:
            obj.label = "formWrh.friend";
            obj.value = 4
            break;
        }
        // obj.value = index + 1;
        return obj;
    }); // 婚姻状况

    @Watch("detailInfo")
    onDetailInfoChanged(val: any) {
        if (val) {
            this.detailInfo.family.familyaddrphoto == 0 ? this.detailInfo.family.familyaddrphoto = '' : this.detailInfo.family.familyaddrphoto
            this.detailInfo.family.contactList.forEach((item:any,index:any) => {
                item.itemId = index
            });
            this.detailForm = JSON.parse(JSON.stringify(this.detailInfo.family))
            this.familyForm = JSON.parse(JSON.stringify(this.detailInfo.family))
            if(this.imgShow){
                this.previewImg(this.familyForm.familyaddrphoto,'edit')
            }
            this.$emit('initForm',this.familyForm,'4')
        }
    }

    private created () {
        this.$emit('initForm',this.familyForm,'4')
    }
    // submit
    private submitForm(formName:string){
        let ref: any = this.$refs[formName];
        ref.validate((valid:any) => {
            if (valid) {
                // if(this.familyForm.fileList && this.familyForm.fileList.length > 0 && this.familyForm.fileList[0].url){
                    this.familyForm.panelstatus = 0
                    this.$emit('submitForm',this.familyForm,'4')
                // }else{
                //     this.$message({
                //         type: "error",
                //         message: "please upload"
                //     });
                // }
            } else {
                return false;
            }
        });
    }
    // reset
    private  resetForm(formName:string) {
        let ref: any = this.$refs[formName];
        ref.resetFields();
        this.familyForm.contactList.forEach((item:any,index:any) => {
            if(item.id == 0){
                this.familyForm.contactList.splice(index,1)
            }
        });
        this.$emit('resetForm','4')
    }

    // show add
    private addInfo () {
        this.familyForm.fileList = [] 
        this.$emit('addForm','4')
    }

    // edit
    private editInfo () {
        this.familyForm = JSON.parse(JSON.stringify(this.detailInfo.family))
        if(this.familyForm.familyaddrphoto == '' || this.familyForm.familyaddrphoto == 0){
            this.familyForm.fileList = [] 
        }else {
            this.previewImg(this.familyForm.familyaddrphoto,'edit')
        }
        this.$emit('editForm','4')
    }

    private addContactList () {
        let list = JSON.parse(JSON.stringify(this.familyForm.contactList))
        // return
        if(list.length > 0){
            let num:any = 0
            for(let i = 0 ; i < list.length ; i++){
                if(list[i].panelstatus == 0){
                    if(list[i].contact == '' || list[i].relationship == ''){
                        num++ 
                    }
                }
            }
            if(num == 0){
                this.familyForm.contactList.push({
                    id:0,
                    contact:'',
                    relationship:'',
                    panelstatus:0,
                    itemId:this.familyForm.contactList.length
                })
            }
        }else{
            this.familyForm.contactList.push({
                id:0,
                contact:'',
                relationship:'',
                panelstatus:0,
                itemId:this.familyForm.contactList.length
            })
        }
    }

    private deleteContact (index:any){
        let list = this.familyForm.contactList
        // 点击删除则直接把状态置为1，如果是新增，服务端会自动删除掉该条数据
        list[index].panelstatus = 1
        this.$forceUpdate()
    }

    private onExceed() {
        this.$message({
            type: "error",
            message: "should be less than 1 files."
        });
    }

    private deleteInfo () {
        //弹框提示是否删除
        this.dialogVisible = true
    }
    private cancelConfirm () {
        this.dialogVisible = false
    }
    private deleteConfirm () {
        this.dialogVisible = false
        this.$emit('deleteForm','4')
    }

    private photoChange(val: any, list:[]) {
        let that = this;
        that.btnClick = true
        that.btnType = 'info'
        let reg = /png|jpg|jpeg/g;
        if(/png|jpg|jpeg/g.test(val.raw.type) && val.raw.size <= 500000) {
            let reader:any = new FileReader();
            reader.readAsArrayBuffer(val.raw);
            reader.onload = function () {
                let file = new Uint8Array(this.result);
                dataCenter.commonApi.peopleManagementImg({
                    setRelatedid: that.baseUserInfo.id,
                    setContenttype: val.raw.type,
                    setExten: (val.raw.name.match(/\.[a-zA-Z]+$/g))[0],
                    setData: file,
                    setUsemark:1
                }).then((res: any)=> {
                    //记录当前上传的id  
                    that.familyForm['familyaddrphoto'] = res.resourceid
                    that.familyForm.fileList = list;
                    that.btnClick = false
                    that.btnType = 'primary'
                },(oError:any)=> {
                    that.familyForm.fileList = [];
                    that.btnClick = false
                    that.btnType = 'primary'
                })
            }
        }else {
            that.btnClick = false
            that.btnType = 'primary'
            this.familyForm.fileList = [];
            this.detailForm.fileList = [];
            that.$message({
                type: "error",
                message: "jpg/png only,less than 500k"
            });
        }
    }

    private async previewImg(id:any,type:any) {
        const { downloadDocumentReq }: any = await import("@/request/peopleManagement");
        let _arg = {resourceid: String(id),usermark:1};
        let res = await downloadDocumentReq(_arg);
        if (res && res.right) {
            this.url ="data:" + res.mediaheader + ";base64," + res.mediabody;
            if(type === 'edit'){
                let obj = {
                    url:this.url
                }
                this.familyForm.fileList = []
                this.familyForm['fileList'].push(obj)
                this.$forceUpdate()
            }else{
                this.imgShow = true
            }
        }
    }

     // 打开图片查看器
    private openImgViewer(file:any) {
        // 获取要查看的图片临时地址
        this.imgPreviewList = [file.url];
        // 显示图片查看器
        this.showImgViewer = true;
    }

    // 关闭图片查看器
    private closeImgViewer() {
        this.showImgViewer = false;
    }

     private handleRemove (file:any,fileList:any) {
        this.familyForm.fileList = []
        this.detailForm.fileList = []
        this.familyForm.familyaddrphoto = ''
        this.detailForm.familyaddrphoto = ''
    }

    private familyChange(item:any,index:any){
        let list = this.familyForm.contactList
        list.forEach((items:any) => {
            if(items.itemId == index) {
                items.contact = ''
            }
        });
    }

}
